import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ListarPedidosService {

  constructor(private readonly http: HttpClient) { }

  getAllCnpjs(idEmpresa: string, page: number, size:number) {
    const url: string = `/apiconnect/importation/order/company-data/${idEmpresa}/companies?page=${page -1}&size=${size}`;

    return this.http.get(url);
  }

  getAllCnpjsFiltrado(dataInicial: any, dataFinal: any, idEmpresa: any, page: number, size:number) {
    const url: string = `/apiconnect/importation/order/company-data/${idEmpresa}/companies?dataInicial=${dataInicial}&dataFinal=${dataFinal}&page=${page -1}&size=${size}`;

    return this.http.get(url);
  }

  getAllPedidos(idEmpresa: number, dataInicial, dataFinal: any) {
    let url = `/apiconnect/importation/order/lasts/${idEmpresa}/companies`;
    if(dataInicial && dataFinal) {
      url += `?dataInicial=${dataInicial}&dataFinal=${dataFinal}`;
    }
    return this.http.get(url);
  }

  // DETALHAMENTO DO PEDIDO (ABA RESUMO)
  getResumoPedido(idPedido: string, idEmpresa: any) {
    const url: string = `/apiconnect/orders/order/summary/${idPedido}/orders/${idEmpresa}/companies`;

    return this.http.get(url);
  }

  // DETALHAMENTO DO PEDIDO (ABA TAXAS OPERADORAS)
  getTaxasOperadoraPedido(idPedido: string) {
    const url: string = `/apiconnect/orders/order/operators-tax/${idPedido}/orders`;

    return this.http.get(url);
  }

  // DETALHAMENTO DO PEDIDO (ABA LISTA USUÁRIOS)
  getListaUsuariosPedido(idPedido: string) {
    const url: string = `/apiconnect/user-orders/order/users/${idPedido}/orders`;

    return this.http.get(url);
  }

  // Parte de imprimir o RECIBO NO MODAL

  buscaUsuarioCaracter(idPedido: any, campoInput: any) {
    const url: string = `/apiconnect/importation/company/order-users/${idPedido}/orders?campoInput=${campoInput}`;

    return this.http.get(url);
  }

  listarEnderecosFaturamento(idEmpresa: any, idPedido: any) {
    const url: string = `/apiconnect/importation/billing-address/${idEmpresa}/companies`;

    return this.http.get(url);
  }

  listaDepartamentos(idEmpresa: any, idPedido: any) {
    const url: string = `/apiconnect/importation/company/departament/${idEmpresa}/companies?idPedido=${idPedido}`;

    return this.http.get(url);
  }

  imprimirRecibo(idPedido:any, idUsuario: any, idDepartamento: any, idOrdem: any,idEndereco: any) {
    let usuario: any;
    let departamento: any;
    let ordem: any;
    let endereco: any;

    if(idUsuario) { usuario = `userId=${idUsuario}`; } else { usuario = ''; }
    if(idDepartamento) { departamento = `&departmentId=${idDepartamento}`; } else { departamento = ''; }
    if(idOrdem) { ordem = `&ordering=${idOrdem}`; } else { ordem = ''; }
    if(idEndereco) { endereco = `&addressId=${idEndereco}`; } else { endereco = ''; }

    return this.http.get(`/apiconnect/report/receipts-reports/${idPedido}/orders?${usuario}${departamento}${ordem}${endereco}`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  // PARTE DE CANCELAR PEDIDOS
  getAllPedidosCancelar(idEmpresa: string) {
    const url: string = `/apiconnect/orders/order/cancels/${idEmpresa}/companies`;

    return this.http.get(url);
  }

  cancelarPedidos(idPedidos: any) {
    let headers = new HttpHeaders({
      "Content-Type" : "application/json",
      "Accept" : "application/json"
    });

    const body : string = JSON.stringify(idPedidos);

    return this.http.put(`/apiconnect/importation/order/cancel`, body, {
      headers : headers
    });
  }

  getAlldados(idPedido: string) {
    const url: string = `/apiconnect/orders/report/right-refill/data/${idPedido}/orders`;

    return this.http.get(url);
  }

  getRelatorio(idPedido: any){
    return this.http.get (`/apiconnect/orders/report/right-refill/${idPedido}/orders`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  startFileGeneration(idEmpresaLogada) {
    return this.http.get<any>(`/apiconnect/orders/billet-group/${idEmpresaLogada}`);
  }

  public getDownload(fileName, fileNameDownload?) {
    fileNameDownload ??= fileName;

    return this.http.get(`/apiconnect/orders/file/download/${fileName}/files/${fileNameDownload}/files`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  public baixarBoletoPedido ( idPedido ){
    return this.http.get (`/apiconnect/report/billetes/${idPedido}/orders`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  public gerarRelatorioPdf ( idPedido ){
    return this.http.get (`/apiconnect/report/orders-summary-reports/${idPedido}`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  public gerarRelatorioXls ( idEmpresa, idPedido ){
    return this.http.get<any> (`/apiconnect/report/companies/${idEmpresa}/orders/${idPedido}/consolidateds-reports`);
  }

  public gerarArquivoFolha ( idPedido ){
    return this.http.get (`/apiconnect/importation/report/sheet-file/${idPedido}/orders`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  getFileGenerationStatus(idDownload, tipoArquivo: string, idEmpresa: number) {
    const headers = new HttpHeaders().set('api-company-id', idEmpresa.toString());
    return this.http.get<any>(`/apiconnect/core/download-status/${idDownload}/${tipoArquivo}/files`, {headers});
  }
}
